import cn from 'classnames';
import Link from 'next/link';
import { LOGIN_PATHNAME } from '@/shared/constants/pathnames';
import { Text } from '@/shared/ui/core';
import { HaveAnAccountProps } from '../model/have-an-account.props';
import styles from './have-an-account.module.scss';


export const HaveAnAccount = ({ className, href = LOGIN_PATHNAME }: HaveAnAccountProps) => {
    return (
        <Text
            size='lg'
            tone='secondary'
            className={ cn(styles.root, className) }
            lineHeight={ 1.2 }
        >
            Already registered?{ ' ' }
            <Link href={ href }>
                <Text
                    as='span'
                    size='lg'
                    weight='semibold'
                    tone='primary'
                    className={ styles.sign_up }
                >
                    Sign in
                </Text>
            </Link>
        </Text>
    );
};
